import React from 'react';

import {
    Btn,
    Box,
    Container,
    H2,
    P,
    FieldCheckbox,
    ValidationForm,
} from '@saladbob/sassafras';

import Slate from '../Slate';

import type { Optin } from '../../types';

type Props = {
    tournamentTitle: string;
    optins: Optin[]
    onSubmit: (optins: string[]) => void;
    onExit: () => void;
    children: React.ReactNode;
};

const Optins: React.FC<Props> = ({ tournamentTitle, optins, onSubmit, children }) => {
    const submitHandler = (_, data) => {
        const selectedOptins = Object.keys(data).filter((key) => data[key]);
        onSubmit(selectedOptins);
    }
    return (
        <Container>
            <ValidationForm onSubmit={submitHandler}>
                <H2 align="center" mb="lg">Special Opportunities from {tournamentTitle} Organizers</H2>
                {optins && (
                    <Box pt="lg">
                        <Box display="flex" wrap="wrap" justify="center" align="center" mb="lg">
                            {optins.map((optin) => (
                                <Box padding="xs" maxWidth="600px" key={optin.id}>
                                    <FieldCheckbox name={optin.id} value={optin.id} size="xs" label={(<P>
                                        <Slate content={optin.description} />
                                    </P>)}/>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                )}
                <Box display="flex" justify="center" align="center" mb="lg">
                    <Btn type="submit" margin="0 auto" size="lg" font="leader">Continue</Btn>
                </Box>
            </ValidationForm>
            {children}
        </Container>
    );
}

export default Optins;
